// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qo-5";
export var filledCircle = "_qo-4";
export var historyEntry = "_qo-3";
export var messageSideLeft = "_qo-1";
export var messageSideRight = "_qo-2";
export var orderTrackingCarouselWrapper = "_qo-6";
export var orderTrackingInfoContainer = "_qo-0";